import { QwickLogo } from "@gigpro/ui/Icons";
import { useBreakpoint } from "@gigpro/ui/utils/useBreakpoint";
import { LocationBar } from "domains/locations/containers/LocationBar";
import { OrganizationSwitcher } from "domains/orgs/containers/OrganizationSwitcher";
import { UserProfileContainer } from "domains/orgs/containers/UserProfile";
import { PowerUserMenu } from "domains/settings/containers/PowerUserMenu";
import { useAtom } from "jotai";
import type { BaseLayoutSlots } from "layouts/BaseLayout";
import { Drawer } from "layouts/BaseLayout/Drawer";
import { NavigationBar } from "layouts/BaseLayout/TopNavigation";
import { MainNavigation } from "layouts/MainNavigation";
import { ModeSwitcher } from "layouts/ModeSwitcher";
import { drawerAtom } from "services/atoms";
import { powerUserMenuAtom } from "services/powerUser";
import { useShiftsNavItems } from "./useShiftsNavItems";
import { useShowHireSwitch } from "./useShowHireSwitch";

type ShiftsMainNavContainerProps = {
  title: string;
  hideDefaultHeader?: boolean;
  slots?: Pick<BaseLayoutSlots, "topNavigation" | "mobileHeader">;
};

export function ShiftsMainNavContainer({ title, hideDefaultHeader, slots }: Readonly<ShiftsMainNavContainerProps>) {
  const isDesktop = useBreakpoint("md");
  const [drawerOpen, setDrawerOpen] = useAtom(drawerAtom);
  const [powerUserMenuOpen, setPowerUserMenuOpen] = useAtom(powerUserMenuAtom);

  const navItems = useShiftsNavItems();
  const showHireSwitch = useShowHireSwitch();

  if (isDesktop) {
    return (
      <>
        <MainNavigation
          logo={<QwickLogo className="mx-2 h-7 shrink-0" />}
          modeSwitcher={showHireSwitch && <ModeSwitcher currentMode="shifts" />}
          mainItems={navItems.main}
          overflowItems={navItems.secondary}
          adminItems={navItems.admin}
          userProfile={
            <div className="flex items-center gap-1">
              <OrganizationSwitcher>
                <UserProfileContainer size="small" className="w-32" />
              </OrganizationSwitcher>
            </div>
          }
          inbox={navItems.inbox}
          agentChat={navItems.agentChat}
        />
        <PowerUserMenu open={powerUserMenuOpen} onOpenChange={setPowerUserMenuOpen} />
      </>
    );
  }
  return (
    <>
      {slots?.topNavigation ?? <NavigationBar title={title} topBar={navItems.topBar} drawerItems={navItems.drawer} />}
      {!hideDefaultHeader && <LocationBar />}
      {slots?.mobileHeader}
      {!!navItems.drawer.length && (
        <Drawer
          open={drawerOpen}
          onOpenChanged={setDrawerOpen}
          items={navItems.drawer}
          slots={{
            bottom: (
              <div className="mx-2 mt-auto mb-2 flex flex-col gap-1 self-stretch">
                {showHireSwitch && <ModeSwitcher currentMode="shifts" className="py-2" />}
                <OrganizationSwitcher>
                  <UserProfileContainer size="small" />
                </OrganizationSwitcher>
              </div>
            ),
          }}
        />
      )}
      <PowerUserMenu open={powerUserMenuOpen} onOpenChange={setPowerUserMenuOpen} />
    </>
  );
}
